import React, { useEffect, useState, useMemo } from "react";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Table, Form } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import ExportToExcel from "../../../../components/ExportToExcel";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";

const TnEInvoiceReportTraining = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("TnE Invoice Report (Training)"));
  }, []);

  const [resource, setResource] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emp, setEmp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [activeClientKey, setActiveClientKey] = useState(null);
  const [activeProjectKeys, setActiveProjectKeys] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    InvoiceDate: true,
    InvoiceNo: true,
    EmployeeName: true,
    Remarks: true,
    InvoicedAmount: true,
    TaxPercent: true,
    ExchangeRate: true,
    InvoiceCalculatedAmount: true,
    PaymentTermDays: true,
    PaymentDueDate: true,
    FollowUpDate: true,
    PaymentReceivedDate: true,
    OverDueDays: true,
  });
  const columns = [
    {
      id: "InvoiceDate",
      label: "Invoice Date",
      accessor: "InvoiceDate",
    },
    { id: "InvoiceNo", label: "Invoice", accessor: "InvoiceNo" },
    { id: "EmployeeName", label: "Employee", accessor: "EmployeeName" },
    { id: "Remarks", label: "Remarks", accessor: "Remarks" },
    { id: "InvoicedAmount", label: "Proforma Amt", accessor: "InvoicedAmount" },
    { id: "TaxPercent", label: "Tax %", accessor: "TaxPercent" },
    { id: "ExchangeRate", label: "Exchange Rate", accessor: "ExchangeRate" },
    {
      id: "InvoiceCalculatedAmount",
      label: "Invoice Amt",
      accessor: "InvoiceCalculatedAmount",
    },
    {
      id: "PaymentTermDays",
      label: "Pymt Tere Day",
      accessor: "PaymentTermDays",
    },
    {
      id: "PaymentDueDate",
      label: "Pymt.Due Date",
      accessor: "PaymentDueDate",
    },
    { id: "FollowUpDate", label: "Follow-up Date", accessor: "FollowUpDate" },
    {
      id: "PaymentReceivedDate",
      label: "Pymt.Recd Date",
      accessor: "PaymentReceivedDate",
    },
    { id: "OverDueDays", label: "OverDue", accessor: "OverDueDays" },
  ];

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };
  const filters = {
    Employee: 0,
  };
  const [filter, setFilter] = useState(filters);
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    Overdue: 0,
  });

  useEffect(() => {
    fetchResourceReport();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchResourceReport = async () => {
    try {
      setLoading(true);
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/12?P_FromDate&P_ToDate&P_OverDueDays`
      );
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching resource report:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return resource.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [resource, searchTerm]);

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    return filteredData.slice(startIndex, endIndex);
  };

  const currentItems = getCurrentItems();

  // Create nested structure for display from the current paginated items
  const nestedData = useMemo(() => {
    return currentItems.reduce((acc, item) => {
      if (!acc[item.ClientName]) {
        acc[item.ClientName] = {};
      }
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});
  }, [currentItems]);

  const handleClientToggle = (clientKey) => {
    if (activeClientKey === clientKey) {
      setActiveClientKey(null);
      setActiveProjectKeys((prev) => {
        const newKeys = { ...prev };
        delete newKeys[clientKey];
        return newKeys;
      });
    } else {
      setActiveClientKey(clientKey);
      // Automatically open the first project when opening a client
      setActiveProjectKeys((prev) => ({
        ...prev,
        [clientKey]: "0", // Open first project by default
      }));
    }
  };

  const handleProjectToggle = (clientKey, projectKey) => {
    setActiveProjectKeys((prev) => {
      const newKeys = { ...prev };
      // If clicking the currently active project in this client, close it
      if (newKeys[clientKey] === projectKey) {
        delete newKeys[clientKey];
      } else {
        newKeys[clientKey] = projectKey;
      }
      return newKeys;
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const handleGetData = async () => {
    const { fromDate, toDate, Overdue } = formData;
    setLoading(true);
    // Format dates only if they exist
    const formattedFromDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    const url = `${API_URL}projectmanagement/reports/12?P_FromDate=${formattedFromDate}&P_ToDate=${formattedToDate}&P_OverDueDays=${
      Overdue || ""
    }`;

    try {
      const response = await GetServiceCaller(url);
      if (response?.status === 200) {
        setResource(response?.data?.data || []);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };
  const customIndicator = {
    display: "inline-block",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginBottom: "0px",
    verticalAlign: "middle",
    marginLeft: "10px",
    marginRight: "3px",
    boxShadow:
      "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
    border: "solid 2px #fff",
  };

const InvoiceExportData = (data, columnVisibility, columns) => {
  // Create nested structure
  const nestedData = data.reduce((acc, item) => {
    if (!acc[item.ClientName]) acc[item.ClientName] = {};
    if (!acc[item.ClientName][item.ProjectName]) {
      acc[item.ClientName][item.ProjectName] = [];
    }
    acc[item.ClientName][item.ProjectName].push(item);
    return acc;
  }, {});

  // Get visible columns
  const visibleColumns = columns.filter(col => columnVisibility[col.id]);

  // Prepare the export data
  const exportData = [];

  // Add header row (only once)
  const headerRow = {};
  visibleColumns.forEach(col => {
    headerRow[col.label] = col.label; // Use label as both key and value
  });
  exportData.push(headerRow);

  // Add data rows with hierarchy
  Object.entries(nestedData).forEach(([clientName, projects]) => {
    // Add client row
    const clientRow = {};
    visibleColumns.forEach((col, index) => {
      clientRow[col.label] = index === 0 ? `Client: ${clientName}` : '';
    });
    exportData.push(clientRow);

    Object.entries(projects).forEach(([projectName, items]) => {
      // Add project row
      const projectRow = {};
      visibleColumns.forEach((col, index) => {
        projectRow[col.label] = index === 0 
          ? `Project: ${projectName} (SOW/PO/SO ${items[0]?.ProjectInvoiceDetailNumber || 'N/A'})` 
          : '';
      });
      exportData.push(projectRow);

      // Add item rows
      items.forEach(item => {
        const row = {};
        visibleColumns.forEach(col => {
          if (['InvoiceDate', 'PaymentDueDate', 'FollowUpDate', 'PaymentReceivedDate'].includes(col.id)) {
            row[col.label] = moment(item[col.accessor]).format('DD-MMM-YYYY');
          } else {
            row[col.label] = item[col.accessor] || '';
          }
        });
        exportData.push(row);
      });
    });
  });

  return exportData;
};
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="table-responsive">
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <div className="me-1">
                  <SearchBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
                >
                  <div className="btn-group me-2">
                    <button
                      type="button"
                      className="dropdown-toggle skill-button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={() => setShowDropdown(!showDropdown)}
                      id="excel-btn"
                    >
                      <i className="bi bi-funnel-fill"></i>
                    </button>
                    <ul
                      className={`dropdown-menu p-2 project-status-filter ${
                        showDropdown ? "show" : ""
                      }`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <label className="form-label">From Date</label>
                          <CustomDatePicker
                            name="fromDate"
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            handleChange={(e) => handleChange(e)}
                            value={formData.fromDate}
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">To Date</label>
                          <CustomDatePicker
                            name="toDate"
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            handleChange={(e) => handleChange(e)}
                            value={formData.toDate}
                          />
                        </div>
                        <div className="col-sm-3 mt-4">
                          <label
                            htmlFor="flexSwitchCheckChecked"
                            className="form-label me-2"
                          >
                            Overdue
                          </label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="Overdue"
                            id="flexSwitchCheckChecked"
                            checked={formData.Overdue === 1}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="text-end">
                          <button
                            className="custom-btn mx-2"
                            onClick={() => {
                              setFormData({
                                fromDate: "",
                                toDate: "",
                                Overdue: 0,
                              });
                              setShowDropdown(false);
                              fetchResourceReport();
                            }}
                          >
                            Reset
                          </button>
                          <button
                            className="custom-btn"
                            onClick={() => {
                              handleGetData();
                              setShowDropdown(false);
                            }}
                          >
                            Get Data
                          </button>
                        </div>
                      </div>
                    </ul>
                  </div>
                </OverlayTrigger>
              </div>
              <div className="d-flex justify-content-end">
                <div className="me-1">
                  {/* <ExportToExcel
                    data={resource}
                    filename="TnE Invoice Report (Training).csv"
                  /> */}
                  <ExportToExcel
                    data={InvoiceExportData(
                      resource,
                      columnVisibility,
                      columns
                    )}
                    filename="TnE Invoice Report (Training).csv"
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <div className="me-1">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">Column Chooser</Tooltip>
                      }
                    >
                      <div className="btn-group me-2">
                        <button
                          type="button"
                          className="dropdown-toggle skill-button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="excel-btn"
                        >
                          <i className="bi bi-list"></i>
                        </button>
                        <ul className="dropdown-menu p-2">
                          <div className="row">
                            <Form.Group>
                              {columns.map((column) => (
                                <Form.Check
                                  key={column.id}
                                  type="checkbox"
                                  id={`checkbox-${column.id}`}
                                  label={column.label}
                                  checked={columnVisibility[column.id]}
                                  onChange={() =>
                                    toggleColumnVisibility(column.id)
                                  }
                                />
                              ))}
                            </Form.Group>
                          </div>
                        </ul>
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-1 d-flex align-items-center">
              <p style={{ ...customIndicator, background: "#bad893" }}></p>
              <span className="me-3">FixedBid</span>
              <p style={{ ...customIndicator, background: "#ffe4a4" }}></p>
              <span>Consolidated</span>
            </div>

            {/* Table with blue scrollbar container */}
            <div
              className="blue-scrollbar"
              style={{ overflowX: "auto", paddingBottom: "5px" }}
            >
              <Table
                bordered
                striped
                hover
                style={{
                  minWidth: "100%",
                  width: "max-content",
                  marginBottom: "0",
                }}
              >
                <thead id="thcolor" className="text-center">
                  <tr>
                    <th style={{ width: "60px" }}>##</th>
                    {columnVisibility.InvoiceDate && (
                      <th style={{ width: "100px" }}>Inv Date</th>
                    )}
                    {columnVisibility.InvoiceNo && (
                      <th style={{ width: "100px" }}>Invoice</th>
                    )}
                    {columnVisibility.EmployeeName && (
                      <th style={{ width: "150px" }}>Emp. Name</th>
                    )}
                    {columnVisibility.Remarks && (
                      <th style={{ width: "200px" }}>Remark</th>
                    )}
                    {columnVisibility.InvoicedAmount && (
                      <th style={{ width: "120px" }}>Proforma Amt</th>
                    )}
                    {columnVisibility.TaxPercent && (
                      <th style={{ width: "80px" }}>Tax %</th>
                    )}
                    {columnVisibility.ExchangeRate && (
                      <th style={{ width: "120px" }}>Exchange Rate</th>
                    )}
                    {columnVisibility.InvoiceCalculatedAmount && (
                      <th style={{ width: "120px" }}>Invoice Amt</th>
                    )}
                    {columnVisibility.PaymentTermDays && (
                      <th style={{ width: "120px" }}>Pymt Term Day</th>
                    )}
                    {columnVisibility.PaymentDueDate && (
                      <th style={{ width: "120px" }}>Pymt Due Date</th>
                    )}
                    {columnVisibility.FollowUpDate && (
                      <th style={{ width: "120px" }}>Follow-up Date</th>
                    )}
                    {columnVisibility.PaymentReceivedDate && (
                      <th style={{ width: "120px" }}>Pymt Recd Date</th>
                    )}
                    {columnVisibility.OverDueDays && (
                      <th style={{ width: "100px" }}>Overdue</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={21} className="text-center py-4">
                        <div className="d-flex justify-content-center">
                          <FaSpinner class="spinner" />
                        </div>
                        <div className="text-muted mt-2">Loading</div>
                      </td>
                    </tr>
                  ) : Object.keys(nestedData).length === 0 ? (
                    <tr>
                      <td colSpan={21} className="text-center text-muted py-3">
                        No Record Found
                      </td>
                    </tr>
                  ) : (
                    Object.entries(nestedData).map(
                      ([clientName, projects], clientIndex) => {
                        return (
                          <React.Fragment key={`client-${clientIndex}`}>
                            {/* Client Row */}
                            <tr className="bg-light">
                              <td colSpan={21} className="fw-bold">
                                {clientName || ""}
                              </td>
                            </tr>

                            {Object.entries(projects).map(
                              ([projectName, items], projectIndex) => {
                                return (
                                  <React.Fragment
                                    key={`project-${clientIndex}-${projectIndex}`}
                                  >
                                    {/* Project Row */}
                                    <tr className="bg-light">
                                      <td
                                        colSpan={21}
                                        className="ps-4"
                                        style={{
                                          backgroundColor: "#DBEAC8",
                                          color: "black",
                                        }}
                                      >
                                        {projectName || ""}
                                        <span className="text-muted">
                                          {" "}
                                          (SOW/PO/SO{" "}
                                          {items[0]
                                            ?.ProjectInvoiceDetailNumber ||
                                            "N/A"}
                                          )
                                        </span>
                                      </td>
                                    </tr>

                                    {/* Items Rows */}
                                    {items.map((data, itemIndex) => (
                                      <tr
                                        key={`item-${clientIndex}-${projectIndex}-${itemIndex}`}
                                        className="border"
                                      >
                                        <td style={{ width: "60px" }}></td>
                                        {columnVisibility.InvoiceDate && (
                                          <td
                                            style={{
                                              width: "100px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {moment(data.InvoiceDate).format(
                                              "DD-MMM-YYYY"
                                            )}
                                          </td>
                                        )}
                                        {columnVisibility.InvoiceNo && (
                                          <td style={{ width: "100px" }}>
                                            {data.InvoiceNo || ""}
                                          </td>
                                        )}
                                        {columnVisibility.EmployeeName && (
                                          <td style={{ width: "150px" }}>
                                            {data.EmployeeName || ""}
                                          </td>
                                        )}
                                        {columnVisibility.Remarks && (
                                          <td style={{ width: "200px" }}>
                                            {data.Remarks || ""}
                                          </td>
                                        )}
                                        {columnVisibility.InvoicedAmount && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "end",
                                            }}
                                          >
                                            {data.InvoicedAmount || ""}
                                          </td>
                                        )}
                                        {columnVisibility.TaxPercent && (
                                          <td
                                            style={{
                                              width: "80px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {data.TaxPercent || ""}
                                          </td>
                                        )}
                                        {columnVisibility.ExchangeRate && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {data.ExchangeRate || ""}
                                          </td>
                                        )}
                                        {columnVisibility.InvoiceCalculatedAmount && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "end",
                                            }}
                                          >
                                            {data.InvoiceCalculatedAmount || ""}
                                          </td>
                                        )}
                                        {columnVisibility.PaymentTermDays && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {data.PaymentTermDays || ""}
                                          </td>
                                        )}
                                        {columnVisibility.PaymentDueDate && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {moment(data.PaymentDueDate).format(
                                              "DD-MMM-YYYY"
                                            )}
                                          </td>
                                        )}
                                        {columnVisibility.FollowUpDate && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {moment(data.FollowUpDate).format(
                                              "DD-MMM-YYYY"
                                            )}
                                          </td>
                                        )}
                                        {columnVisibility.PaymentReceivedDate && (
                                          <td
                                            style={{
                                              width: "120px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {moment(
                                              data.PaymentReceivedDate
                                            ).format("DD-MMM-YYYY")}
                                          </td>
                                        )}
                                        {columnVisibility.OverDueDays && (
                                          <td
                                            style={{
                                              width: "100px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {data.OverDueDays || "0"}
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </React.Fragment>
                                );
                              }
                            )}
                          </React.Fragment>
                        );
                      }
                    )
                  )}
                </tbody>
              </Table>
            </div>

            <div className="d-flex justify-content-between mb-3 mt-2">
              <div>
                <span className="d-flex align-items-center">
                  Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                  {Math.min(currentPage * itemsPerPage, filteredData.length)} of{" "}
                  {filteredData.length} <span className="ms-1">results</span>
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      const newItemsPerPage = Number(e.target.value);
                      setItemsPerPage(newItemsPerPage);
                      setCurrentPage(1); // Reset to first page when changing items per page
                    }}
                    className="mx-2 form-select-sm"
                  >
                    {recordsPerPageOption.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div>
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TnEInvoiceReportTraining;
